function VoucherRequestController($scope, VoucherService, $sce, PermissionService) {
    var self = this;

    /**
     * Initialises the controller and sets up the scope variables
     */
    self.initialise = function() {
        self.userContext = PermissionService.userContext;

        //Get the userid for template replacement and fire the get voucher request template call
        PermissionService.$initialised.then(
            function () {
                self.userId = PermissionService.user.Id;
                self.getVoucherRequestTemplate();
            },
            function failure () {
                ErrorService.showError('An error occurred while initialising the permission service');
            }
        );
    };

    /**
     * Load the data for the voucher request
     */
    self.getVoucherRequestTemplate = function () {
        $scope.$root.isLoading = true;

        VoucherService.GetVoucherRequestTemplate().then(
            function (result) {
                var templateValues = {
                    StoreId: self.userContext.StoreId,
                    UserId: self.userId
                };

                var template = _.template(result.data);
                var FormattedContent = template(templateValues);

                $scope.VoucherRequestTemplate = $sce.trustAsHtml(FormattedContent);
            },
            function failure (result) {
                ErrorService.showError('An error occurred when loading the voucher request form', result);
            }
        ).finally(
            function () {
                $scope.$root.isLoading = false;
            }
        );
    };
    self.initialise();
}

angular
    .module('dashboard')
    .component('voucherRequest',
        {
            templateUrl: 'components/voucherrequest/voucherrequest.22cd83c4.html',
            bindings: {},
            controller: ['$scope', 'VoucherService', '$sce', 'PermissionService', VoucherRequestController]
        });